module.exports = __webpack_public_path__ + "static/media/smartphone-cancel-wally.8f7d5584.svg";